import { Responsive, WidthProvider } from "react-grid-layout";
import "./bulletin.scss";
import { Breadcrumb, Dropdown, Form } from "react-bootstrap";
import { toCapitalCase } from "../../core/util/util-functions";
import { getCurrentSelection } from "../../core/services/user.service";
import { FaFilter } from "react-icons/fa";
import useBulletinLogic from "./bulletin-logic";
import SaveEditDashboard from "../../shared/modal/edit-dashboard/edit-dashboard-modal";
import { LoaderScreenFactory } from "@common/loader";
import { ChatScreenFactory } from "@widget/chat";
import { ChartScreenFactory } from "@widget/chart";
import { TbNewSection } from "react-icons/tb";
import { FaSave } from "react-icons/fa";
import { VscSaveAll } from "react-icons/vsc";
import { FaDownload } from "react-icons/fa6";
import { FaShareFromSquare } from "react-icons/fa6";

export default function BulletinPage() {

  const { showFilterCard, setShowFilterCard, handleLayoutChanges, setShowSaveDashboardModal, showSaveDashboardModal,
    handleCloseModal, bulletinDetail, stateObject, isChatCollapsed, setIsChatCollapsed, bulletinId, chatData, createWidgetDataFromNlqResult, filterData,
    addSection, handleFilterSelect, filteredData, resetChatData
  } = useBulletinLogic();

  const ResponsiveGridLayout = WidthProvider(Responsive);
  const defaultProps = {
    className: "layout",
    cols: { lg: 12, md: 12, sm: 6, xs: 4, xxs: 2 },
    rowHeight: 10,
    containerPadding: [0, 0] as [number, number],
    draggableHandle: ".drag-handle",
    onLayoutChange: handleLayoutChanges
  };

  return (
    <div className="bulletin-wrapper">
      <div className="row options-section">
        <div className="col-sm-12 col-md-6">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>{toCapitalCase(getCurrentSelection().name)}</Breadcrumb.Item>
            <Breadcrumb.Item active>Bulletin</Breadcrumb.Item>
            {/* {
              dashboardId.id != '0' ? <Breadcrumb.Item active>{dashboardDetail?.title?.toLowerCase()}</Breadcrumb.Item> : <Breadcrumb.Item active>Unsaved Dashboard</Breadcrumb.Item>
            } */}
          </Breadcrumb>
        </div>
        <div className="col-sm-12 col-md-6 dashboard-options">
          <div title="Filter" className="btn btn-sm mr-2 left transparent" onClick={() => setShowFilterCard(!showFilterCard)}><FaFilter /></div>
          <Dropdown title="Add section" className=" mr-2 transparent">
            <Dropdown.Toggle id="dropdown-basic">
              <TbNewSection />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => addSection("GEO")}>Geo Chart</Dropdown.Item>
              <Dropdown.Item onClick={() => addSection("AGGREGATE")}>Aggregated Table</Dropdown.Item>
              <Dropdown.Item onClick={() => addSection("PREDICTION_CHART")}>Prediction</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {/* <div className="btn btn-sm mr-2" onClick={() => addWidget()}>Add Widget</div> */}
          <div title="Save Bulletin" className="btn btn-sm mr-2 transparent" onClick={() => setShowSaveDashboardModal(true)}><FaSave /></div>
          <div title="Save a copy" className="btn btn-sm ml-2 transparent" onClick={() => setShowSaveDashboardModal(true)}><VscSaveAll /></div>
          <div title="Export data" className="btn btn-sm ml-2 transparent"><FaDownload /></div>
          <div title="Export data" className="btn btn-sm ml-2 transparent"><FaShareFromSquare /></div>
        </div>
      </div>
      {
        showFilterCard ? <div className="card filter-card">
          <div className="card-body">
            {
              bulletinDetail && chatData && filterData && filterData.length > 0 && filterData.map((filter) => {
                return (
                  <Form.Group className="filter-form d-flex" controlId="formGridState">
                    <Form.Label>{filter.title}</Form.Label>
                    <Form.Select defaultValue="Choose..." onChange={() => handleFilterSelect(event, filter.colName)}>
                      <option>Select filter...</option>
                      {
                        filter.options.map((opt) => {
                          return (
                            <option value={opt.value}>{opt.key}</option>
                          )
                        })
                      }
                    </Form.Select>
                  </Form.Group>
                )
              })
            }
            {/* <div className="btn btn-sm ml-5" onClick={filterDataOnSelectedKeys}>Apply</div> */}
            <div className="btn btn-sm transparent ml-5" onClick={resetChatData}>Reset</div>
          </div>
        </div> : <></>
      }
      <div className="content-wrapper">
        <div className="dashboard-section">
          {
            stateObject.callInProgress ? <LoaderScreenFactory /> :
              <ResponsiveGridLayout {...defaultProps}>
                {
                  bulletinDetail && chatData && filteredData && bulletinDetail.template_json.map((layout) => {
                    const widgetData = createWidgetDataFromNlqResult(filteredData, layout);

                    if (widgetData.widgetType === 'DNS') return null;

                    return (
                      <div key={layout.i} data-grid={{ x: layout.x, y: layout.y, w: layout.w, h: layout.h }}>
                        <ChartScreenFactory key={'chart-widget-' + layout.i} widgetData={widgetData} />
                      </div>
                    );
                  })
                }
              </ResponsiveGridLayout>
          }
        </div>
        <div className={`chat-container ${isChatCollapsed ? "collapsed" : ""}`}>
          <button className="chat-toggle" onClick={() => setIsChatCollapsed(!isChatCollapsed)}>Chat</button>
          <div className="chat-box">
            <div className="chat-header">
              <span>Chat with AI</span>
              <button className="close-btn" onClick={() => setIsChatCollapsed(true)}>✖</button>
            </div>
            <div className="chat-body">
              {
                !stateObject.callInProgress && <ChatScreenFactory />
              }

            </div>
          </div>
        </div>
      </div>
      {
        bulletinDetail && showSaveDashboardModal ? <SaveEditDashboard showModal={showSaveDashboardModal} handleCloseModal={handleCloseModal} dashboardDetail={bulletinDetail} isEdit={!(bulletinId.id == "0")} /> : <></>
      }
    </div>
  )
}